import { Component, Input } from '@angular/core';

export interface SeatAvailabilityItem {
  flightNumber: string;
  availableSeats?: number | null;
}

@Component({
  selector: 'app-seat-availability',
  templateUrl: './seat-availability.component.html',
  styleUrls: ['./seat-availability.component.scss'],
  standalone: false
})
export class SeatAvailabilityComponent {
  @Input() items: SeatAvailabilityItem[] = [];
}
